// /*********************** Custom JS for Boost AI Search & Discovery  ************************/

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat((registry) => {
  const store = window.Shopify?.shop;
	const collectionAllId = 283687813173;

  if (store === 'tumble-dev-2.myshopify.com') {
    return
  }

  registry.useModulePlugin('FilterAPI', {
    name: 'Extra params filter in collection page',
    apply(builder) {
      builder.on('beforeMethodCall', 'get', (payload) => {
        if(payload.args[0].collection_scope === 0) {
          payload.args[0].collection_scope = collectionAllId;
        }
      });
    },
  });

  registry.useModulePlugin('SearchAPI', {
    name: 'Extra params SearchAPI',
    apply(builder) {
      // Logic run filter in search page, please only edit in TODO: do something - ts
      builder.on('beforeMethodCall', 'searchInCollection', (payload) => {
        const filterParams = payload.args[0];
        let isApiFilterInSearchPage = false;
        if(!filterParams) return;

        const keys = Object.keys(filterParams);
        if(keys?.length > 0) {
          for(let i = 0; i < keys.length; i++) {
            if(keys[i].startsWith('pf_')) {
              isApiFilterInSearchPage = true;
              break;
            }
          }
        }

        if(isApiFilterInSearchPage) {
          if(payload.args[0].collection_scope === 0) {
            payload.args[0].collection_scope = collectionAllId;
            payload.args[0].collectionId = collectionAllId;
          }
        }
      });
    },
  });
});
